import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LaboratoryListComponent } from './components/laboratory-list/laboratory-list';
import { LaboratoryOrdersComponent } from './components/laboratory-orders/laboratory-orders';
import { AppTabs } from '../../shared/components/app-tabs/app-tabs';
import { TranslateModule } from '@ngx-translate/core';
import { PageShell } from '../../shared/components/page-shell/page-shell';

@Component({
  selector: 'app-laboratory',
  standalone: true,
  imports: [
    CommonModule, 
    LaboratoryListComponent, 
    LaboratoryOrdersComponent,
    AppTabs,
    TranslateModule,
    PageShell
  ],
  template: `
    <app-page-shell [title]="'laboratories' | translate" [description]="'laboratories_desc' | translate">
      <div class="mb-8">
        <app-tabs 
          [items]="tabs" 
          [activeValue]="activeTab" 
          (activeValueChange)="activeTab = $event">
        </app-tabs>
      </div>

      <ng-container [ngSwitch]="activeTab">
        <app-laboratory-list *ngSwitchCase="'laboratories'"></app-laboratory-list>
        <app-laboratory-orders *ngSwitchCase="'orders'"></app-laboratory-orders>
      </ng-container>
    </app-page-shell>
  `
})
export class LaboratoryComponent {
  activeTab = 'laboratories';

  tabs = [
    { label: 'laboratory_tab_list', value: 'laboratories' },
    { label: 'laboratory_tab_orders', value: 'orders' }
  ];
}
